import { useCallback, useRef } from 'react';
import { useInView } from 'react-intersection-observer';

export const useAutoPlayVideoWhenVisible = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const cb = useCallback(
    async (_, entry: IntersectionObserverEntry) => {
      if (!videoRef.current || !entry?.target) return;

      if (entry.isIntersecting) {
        try {
          await videoRef.current.play();
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          await videoRef.current.pause();
        } catch (e) {
          console.log(e);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [videoRef.current]
  );
  const [inviewRef] = useInView({
    threshold: 0.5,
    fallbackInView: true,
    onChange: cb,
  });

  const setRefs = useCallback(
    node => {
      videoRef.current = node;

      inviewRef(node);
    },
    [inviewRef]
  );

  return setRefs;
};
